/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import { projectStateConfig } from '@config';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    methods: {
        validProject(project) {
            const organisation = project.organisation;

            // Organisation
            if (!organisation.community) {
                if (!organisation.kvk)
                    return false;

                if (!organisation.file_types.includes('statuten') && !organisation.file_types.includes('jaarrekening'))
                    return false;
            }

            // Community
            if (organisation.community) {
                // Check for 3 contacts
            }

            // Project
            if (
                !project.title || 
                !project.starts_at || 
                !project.amount ||
                project.amount === '0' ||
                !project.file_types.includes('projectplan') ||
                !project.file_types.includes('begroting-dekking') ||
                !project.file_types.includes('offerte')
            ) {
                return false;
            }

            

            return true;
        },

        getProjectPath(project) {
            const routeConfig = projectStateConfig[project.state].route;
            const organisation = project.organisation;

            if (routeConfig !== 'continue') {
                return routeConfig.replace('[projectId]', project.id);
            }

            // Organisation
            if (!organisation.community) {
                if (!organisation.kvk) {
                    return `/apply/${ project.id }/applicant/kvk`;
                }
                if (!organisation.file_types.includes('statuten') && !organisation.file_types.includes('jaarrekening')) {
                    return `/apply/${ project.id }/applicant/tekenbevoegd-vereist`;
                }
            }

            // Community
            if (organisation.community) {

            }

            // Project
            if (!project.starts_at) {
                return `/apply/${ project.id }/project/aanvang`;
            }

            if (!project.title || !project.file_types.includes('projectplan')) {
                return `/apply/${ project.id }/project/projectplan`;
            }

            if (!project.file_types.includes('begroting-dekking')) {
                return `/apply/${ project.id }/project/begroting`;
            }

            if (!project.file_types.includes('offerte')) {
                return `/apply/${ project.id }/project/offertes`;
            }

            if (!project.amount || project.amount === '0') {
                return `/apply/${ project.id }/project/bedrag`;
            }

            return `/apply/${ project.id }/confirmation/bevestig`;
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ProjectMixin extends Vue {}